import { createAction } from 'redux-actions';

export const getFollowUpsRequest = createAction('GET_FOLLOW_UPS_REQUEST');
export const getFollowUpsSuccess = createAction('GET_FOLLOW_UPS_SUCCESS');
export const getFollowUpsFail = createAction('GET_FOLLOW_UPS_FAIL');
export const cleanupFollowUps = createAction('CLEANUP_FOLLOW_UPS');
